<template>
  <el-dialog
    v-if="currentDetail && driverUid"
    :title="formatDate(currentDetail.date, 'YYYY/MM/DD') + ' өдөр'"
    :visible.sync="isShow"
    :close-on-click-modal="isOpenDialog"
    @close="mCloseFunction"
    @closed="mCloseFunction"
    :before-close="mCloseFunction"
    >
      <el-table
        style="width: 100%; background-color: #fff"
        :data="orders"
        max-height="607"
        v-loading="orderDetailLoading"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column prop="order_number" label="Дугаар"></el-table-column>
        <el-table-column prop="kilometer" label="Явсан (км)">
          <template slot-scope="prop">
            {{ prop.row.kilometer ? prop.row.kilometer : '0' }} км
          </template>
        </el-table-column>
        <el-table-column prop="base_salary" label="Үндсэн ү/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.base_salary) ? formatPrice(prop.row.base_salary) : '-' }}₮
          </template>
        </el-table-column>
        <el-table-column prop="salary" label="Олгох ү/төлбөр">
          <template slot-scope="prop">
            {{ formatPrice(prop.row.salary) ? formatPrice(prop.row.salary) : '-' }}₮
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
</template>
<script>
import services from '@/helpers/partnerServices.js'
export default {
  name: 'DriverDetailLog',
  props: {
    currentDetail: Object,
    isShow: Boolean,
    closeDialogDetail: Function,
    formatDate: Function,
    close: Function,
    formatPrice: Function,
    driverUid: String
  },
  data () {
    return {
      isOpenDialog: false,
      orderDetailLoading: false,
      orders: []
    }
  },
  created () {
    this.getDSettlementsDayOrderData()
  },
  methods: {
    getDSettlementsDayOrderData () {
      this.orderDetailLoading = true
      const payload = {
        driver_uid: this.driverUid,
        date: this.currentDetail.date
      }
      services.getDSettlementsDayOrderData(payload).then((response) => {
        if (response.status === 'success') {
          this.orders = response.data
          this.orderDetailLoading = false
        } else {
          this.orders = []
          this.orderDetailLoading = false
        }
      })
    },
    mCloseFunction () {
      this.closeDialogDetail()
    }
  }
}
</script>
